import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { safeSessionStorage as sessionStorage } from "@/lib/safeStorage";

export const GOOGLE_LINK_PATH = "/app/sicurezza";


export function useGoogleError() {
  const location = useLocation(), navigate = useNavigate();
  const [error, setError] = useState(location.state?.googleError || "");
  useEffect(() => {
    if (location.state?.googleError) {
      setError(location.state.googleError);
      navigate(location.pathname + location.search + location.hash, { replace: true, state: { ...location.state, googleError: null } });
    }
  }, [location, navigate]);
  return [error, () => setError("")];
}

const base64url = (bytes) => btoa(String.fromCharCode(...bytes)).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");

export async function startGoogle(mode = "login") {
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const redirectUri = window.location.origin + "/auth/google";
  const verifier = base64url(crypto.getRandomValues(new Uint8Array(32)));
  const digest = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(verifier));
  const { data } = await api.post("/auth/google/start", { mode, redirect_uri: redirectUri, code_challenge: base64url(new Uint8Array(digest)) });
  if (!sessionStorage.setItem("google_oauth_context", JSON.stringify({ state: data.state, verifier, mode }))) {
    throw new Error("Il browser blocca la memoria necessaria per Google. Consenti la memoria del sito oppure usa email e password.");
  }
  window.location.assign(data.authorization_url);
}
